import IT4KidsButton from './Button';

export default IT4KidsButton;
